// Canonical role keys
export function normalizeRole(cargo, email) {
    if (email === 'orbioncontato@gmail.com') return 'gestor';
    const c = (cargo || '').toLowerCase().trim();
    if (c.includes('gestor') || c === 'admin') return 'gestor';
    if (c.includes('closer')) return 'closer';
    if (c.includes('farmer')) return 'sales_farmer';
    if (c.includes('social seller') || c === 'social_seller') return 'social_seller';
    if (c === 'sdr') return 'sdr';
    return null;
}

// null roles = open to all authenticated
export const ROUTE_PERMISSIONS = {
    '/nova-venda':           ['closer', 'sales_farmer', 'gestor'],
    '/diario-sdr':           ['sdr', 'gestor'],
    '/diario-social-seller': ['social_seller', 'gestor'],
    '/diario-closer':        ['closer', 'gestor'],
    '/diario-sales-farmer':  ['sales_farmer', 'gestor'],
    '/registro-envios':      ['sdr', 'social_seller', 'closer', 'gestor'],
    '/registro-eventos':     ['sdr', 'social_seller', 'closer', 'sales_farmer', 'gestor'],
    '/cadastro-leads':       ['sdr', 'social_seller', 'closer', 'sales_farmer', 'gestor'],
    '/calendario':           ['sdr', 'social_seller', 'closer', 'sales_farmer', 'gestor'],
    '/configuracoes':        ['gestor'],
    '/comissionamento':      ['gestor'],
};

export function canAccess(role, path) {
    const allowed = ROUTE_PERMISSIONS[path];
    if (!allowed) return true;
    if (!role) return false;
    return allowed.includes(role);
}

export function getDefaultRoute() {
    return '/calendario';
}
